import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks,
} from 'body-scroll-lock';

var hamburger = {
    selector: '[data-navigation="trigger"]',
    init: function () {
        var self = this,
            $hamburger = $(self.selector),
            $navigation = $('.navigation');

        var navigation = document.querySelector('.navigation__container');

        $hamburger.on('click', function (e) {
            e.preventDefault();
            $navigation.addClass('navigation--animate');

            if ($(document.body).hasClass('search-opened')) {
                $(document.body).removeClass('search-opened');
                clearAllBodyScrollLocks();
                return;
            }

            $(document.body).toggleClass('navigation-opened');

            if ($(document.body).hasClass('navigation-opened')) {
                disableBodyScroll(navigation, { reserveScrollBarGap: true });
            } else {
                clearAllBodyScrollLocks(navigation);
            }
        });
    },
};

export { hamburger };
